/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
{
  function triggerDeliveryPopup() {
    document.getElementById("delivery-popup").setAttribute("aria-hidden", "false");
  }
  var deliveryPopupTriggers = document.getElementsByClassName("delivery-popup-trigger");
  for (var i = 0; i < deliveryPopupTriggers.length; i++) {
    deliveryPopupTriggers[i].addEventListener('click', triggerDeliveryPopup, false);
  }
  document.getElementById("delivery-popup-close").addEventListener("click",function () {
    document.getElementById("delivery-popup").setAttribute("aria-hidden", "true");
  }, false);
  
  function triggerDoubletimePopup() {
    document.getElementById("doubletime-popup").setAttribute("aria-hidden", "false");
  }
  var doubletimePopupTriggers = document.getElementsByClassName("doubletime-popup-trigger");
  for (var i = 0; i < doubletimePopupTriggers.length; i++) {
    doubletimePopupTriggers[i].addEventListener('click', triggerDoubletimePopup, false);
  }
  document.getElementById("doubletime-popup-close").addEventListener("click",function () {
    document.getElementById("doubletime-popup").setAttribute("aria-hidden", "true");
  }, false);
}
// Thumbnail-Klick wählt die zugehörige Variante aus (nicht nur das Bild)
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('.product-gallery__thumbnail[data-variant-ids]');
  if (!thumb || !thumb.dataset.variantIds) return;

  var ids = thumb.dataset.variantIds.split(',').filter(Boolean).map(Number);
  if (!ids.length) return;

  var section = thumb.closest('[data-section-type="product"]');
  if (!section) return;

  var master = section.querySelector('select[name="id"], input[name="id"]');
  var currentId = master ? Number(master.value) : null;
  if (ids.indexOf(currentId) !== -1) return; // Bild gehört zur aktuellen Variante

  var jsonEl = section.querySelector('[data-product-json]');
  if (!jsonEl) return;

  var product;
  try {
    product = JSON.parse(jsonEl.textContent).product;
  } catch (err) {
    return;
  }

  var variant = null;
  for (var i = 0; i < product.variants.length; i++) {
    if (product.variants[i].id === ids[0]) { variant = product.variants[i]; break; }
  }
  if (!variant) return;

  var values = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);

  // Options-Selektoren (Radio/Swatch/Dropdown) auf die Zielvariante stellen
  values.forEach(function (value, index) {
    var selectors = section.querySelectorAll('.product-form__single-selector[data-option-position="' + (index + 1) + '"]');
    selectors.forEach(function (input) {
      if (input.tagName === 'SELECT') {
        if (input.value !== value) {
          input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (input.value === value && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
});